import { IconBase, type IconProps } from './IconBase';

export function BoltIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z" />
    </IconBase>
  );
}
